
import util from '../../../util'


const loadUserList = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {

    const headers = util.getAuthHeader()


    payload.context.axios.get('api/users', {headers}).then((response) => {

      commit('setUserList', response.data)

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar los usuarios.')
        reject(error.response)
      }
      reject()

    });

  })

}



const saveUser = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/users',payload.user ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el usuario.')
        reject(error.response)
      }
      reject()

    });
  })
}


const editUser = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/users',payload.user ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el usuario.')
        reject(error.response)
      }
      reject()

    });

  })

}


const enableUser = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch('api/users/'+payload.user.id+'/enable',{} ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al activar el usuario.')
        reject(error.response)
      }
      reject()

    })
  })
}


const disableUser = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch('api/users/'+payload.user.id+'/disable',{} ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al desactivar el usuario.')
        reject(error.response)
      }
      reject()

    })
  })
}



const restorePass = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch('api/users/'+payload.user.id+'/restorepass',{} ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al restablecer el usuario.')
        reject(error.response)
      }
      reject()

    })
  })
}


export default {
  loadUserList,saveUser,editUser,enableUser,disableUser,restorePass
};






// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js